export default {"src":"/_next/static/media/Building.24d4b774.svg","height":131,"width":210,"blurWidth":0,"blurHeight":0};